const getGradientStyles = (status: string) => {
  const gradients: { [key: string]: string } = {
    success: "linear-gradient(135deg, #06E363, #AAFAB1)", // Glacial Green
    error: "linear-gradient(135deg, #E00101, #FE4244)", // Glacial Red
    warning: "linear-gradient(135deg, #F45B0B, #F49113)", // Glacial Orange
    info: "linear-gradient(135deg, #38BBD1, #3EEAEC)", // Primary Gradient
  };
  
  const gradient = gradients[status] || gradients.info;
  
  return {
    container: {
      bgGradient: gradient,
      bg: "transparent",
      color: "white",
      "& *": {
        color: "white !important",
      },
      "& [data-icon]": {
        color: "white !important",
      },
      "& button": {
        color: "white !important",
      },
    },
  };
};

export const alertStyles = {
  components: {
    Alert: {
      defaultProps: {
        variant: "solid",
      },
      variants: {
        solid: (props: any) => {
          const { status } = props;
          return getGradientStyles(status);
        },
        subtle: (props: any) => {
          const { status } = props;
          return getGradientStyles(status);
        },
        "left-accent": (props: any) => {
          const { status } = props;
          return getGradientStyles(status);
        },
        "top-accent": (props: any) => {
          const { status } = props;
          return getGradientStyles(status);
        },
      },
      baseStyle: {
        container: {
          bg: "transparent",
        },
      },
    },
  },
};
